/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verification_Failed_TitleInputs */



/**
* | output |
* | --- |
* | "Verification Failed" |
*
* @param {Creator_Checkout_Verification_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verification_failed_title = /** @type {((inputs?: Creator_Checkout_Verification_Failed_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verification_Failed_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verification echouee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfung fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica fallita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка не удалась")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verificación fallida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("验证失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検証に失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सत्यापन में विफल रहा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verificação falhou")
	return /** @type {LocalizedString} */ ("Verification Failed")
});